export default {
  'Doctoralia.SET_LOADING': function setLoading(state, value) {
    state.loading = value;
  },
  'Doctoralia.SET_DATA': function setData(state, data) {
    state.data = data;
  },
};
